import React from 'react';

import PropTypes from 'prop-types';
import { StackView, Typography } from '@telus-uds/components-web';

import {
  Thead,
  Td,
  Tr,
  Th
} from '../orderDetailsSection/ratePlans/components/css';
import getFormattedPricing from '../orderDetailsSection/utils';

const SummaryGeotabBundles = ({ data, total }) => {
  // Skip bundles with quantity <= 0 (e.g. created when toggling the
  // "More than 50% in US" checkbox, which re-fires the row's persist
  // effect with quantity:0). Raw state is still sent to the backend so
  // it can overwrite previously-saved values; we only suppress empty
  // rows from the summary view.
  const visibleBundles = Object.keys(data).filter(
    item => data[item] && Number(data[item].quantity) > 0
  );
  if (visibleBundles.length === 0) return null;
  return (
    <>
      <StackView space={3}>
        <Typography heading="h4" variant={{ size: 'h4' }} block>Geotab Bundles</Typography>
        <table>
          <Thead>
            <Tr>
              <Th>Geotab Bundle</Th>
              <Th>Unit</Th>
              <Th>Unit Price</Th>
              <Th>Total monthly fee</Th>
            </Tr>
          </Thead>
          <tbody>
            {visibleBundles.map(item => {
              const { quantity, unitPrice } = data[item];
              return (
                <tr>
                  <Td style={{ background: '#f7f7f7', fontWeight: '700' }}>
                    {item}
                  </Td>
                  <Td>{quantity}</Td>
                  <Td>{getFormattedPricing(unitPrice)}</Td>
                  <Td>{getFormattedPricing(unitPrice * quantity)}</Td>
                </tr>
              );
            })}
            <Tr style={{ background: '#f4f4f4' }}>
              <Td colSpan={3}>
                <Typography variant={{ bold: true }}>Total</Typography>
              </Td>
              <Td>
                <Typography variant={{ bold: true }}>{getFormattedPricing(total)}</Typography>
              </Td>
            </Tr>
          </tbody>
        </table>
      </StackView>
    </>
  );
};

SummaryGeotabBundles.propTypes = {
  data: PropTypes.shape({
    quantity: PropTypes.number,
    unitPrice: PropTypes.number
  }).isRequired,
  total: PropTypes.number.isRequired
};

export default SummaryGeotabBundles;
